import React, { useRef, useState, useEffect } from 'react';

const ImageLazyLoad = ({ src, alt, className = '' }) => {
  const containerRef = useRef(null);
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        // When container intersects with viewport
        if (entry.isIntersecting) {
          setIsVisible(true);
          observer.unobserve(containerRef.current); // Stop observing once visible
        }
      },
      {
        root: null, // viewport
        rootMargin: '0px',
        threshold: 0.1 // 10% of the container must be visible
      }
    );

    if (containerRef.current) {
      observer.observe(containerRef.current); // Start observing the container
    }

    return () => {
      if (containerRef.current) {
        observer.unobserve(containerRef.current); // Clean up
      }
    };
  }, [src]);

  return (
    <div 
      ref={containerRef} 
      // relative is needed for the absolute placeholder, min-h ensures the observer has a target height to detect
      className={`${className}`}
    >
      {isVisible ? (
        <img 
          src={src} 
          alt={alt} 
          // object-cover ensures the image fills the container nicely without stretching
          className="w-full h-full object-cover" 
        />
      ) : (
        // animate-pulse creates a standard skeleton loading effect (fading gray)
        <div className="absolute inset-0 bg-gray-200 animate-pulse"></div>
      )}
    </div>
  );
};

export default ImageLazyLoad;